module.exports = __webpack_public_path__ + "static/media/timer-effect-01.29c3440f.png";